import { updateInventoryAsyncResponse } from "./types";
import * as inventoryActions from "./inventories.actions";
import { put, call, takeEvery } from "redux-saga/effects";
import { ErrorResponse } from "../../../interfaces/Response";
import { apiPut, API_URL_INVENTORY, retrieveToken } from "../../../helpers/api";

export function* updateInventorys(action: ReturnType<typeof inventoryActions.updateInventoryAsync.request>) {
  try {
    const token: string = yield retrieveToken();
    if (action.payload.id) {
      const result: Response = yield call(apiPut, API_URL_INVENTORY.UPDATE_INVENTORY(action.payload.id), token, action.payload);
      if (result.status === 200) {
        const parsed: updateInventoryAsyncResponse = yield call(result.json.bind(result));
        yield put(inventoryActions.updateInventoryAsync.success(parsed));
        return;
      } else {
        const parsed: ErrorResponse = yield call(result.json.bind(result));
        yield put(inventoryActions.updateInventoryAsync.failure(parsed));
        return;
      }
    } else {
      const parsed: ErrorResponse = {
        status: 500,
        errors: {},
        message: 'Terjadi kesalahan pada server'
      }
      yield put(inventoryActions.updateInventoryAsync.failure(parsed));  
    }
  } catch (err) {
    const parsed: ErrorResponse = {
      status: 500,
      errors: {},
      message: 'Terjadi kesalahan pada server'
    }
    yield put(inventoryActions.updateInventoryAsync.failure(parsed));
  }
}

export default function* inventoriesSagaUpdateInventory() {
  yield takeEvery(inventoryActions.updateInventoryAsync.request, updateInventorys);
}
